import * as Yup from "yup";

export const filtrosContextoLoteValidator = Yup.object().shape({
  contexto: Yup.string().nullable().required("Contexto é obrigatório"),
  dataVencimentoStart: Yup.date()
    .nullable()
    .when("contexto", {
      is: (context) =>
        context?.endsWith("cobranca") || context?.endsWith("lembrete"),
      then: Yup.date().required("Data Vencimento é obrigatório"),
      otherwise: Yup.date().optional().nullable(),
    }),
  dataVencimentoEnd: Yup.date()
    .nullable()
    .when("contexto", {
      is: (context) =>
        context?.endsWith("cobranca") || context?.endsWith("lembrete"),
      then: Yup.date().required("Data Vencimento é obrigatório"),
      otherwise: Yup.date().optional().nullable(),
    }),
});
